export enum TargetEnvironment {
	Default = 'Default',
	Hero = 'Hero',
}

export interface CognitoConfig {
	domain: string;
	clientId: string;
	scopes: string[];
}
